import {SubscriptionPlanType} from "./subscriptionPlanType";

export class SubscriptionPlan {
    constructor(public type: SubscriptionPlanType,
                public code: string,
                public name: string) {
    }
}
